
import { Vue, Component } from 'vue-property-decorator';
import SelectInput from '~/components/Inputs/Select.vue';
import { AvailableLoan } from '@/interfaces/loan';
import applicationId from '@/filters/application-id';

@Component({ components: { SelectInput } })
export default class ActiveLoanSelector extends Vue {
  get availableLoans() {
    return this.$store.getters['User/availableLoans'].map((loan: AvailableLoan) => {
      return {
        loan_number: loan.loan_number,
        label: `Loan ${applicationId(loan.loan_number)} with ${loan.merchant_name}`,
      };
    });
  }

  get activeLoan(): string | null {
    return this.$store.getters['User/activeLoanNumber'];
  }

  setActiveLoan(loanNumber: string) {
    this.$store.dispatch('User/setActiveLoan', loanNumber);
    window.location.reload();
  }
}
